import { useContext } from "react";
import { LocaleContext } from "../app";

export function Footer() {
  const { translate } = useContext(LocaleContext);

  return (
    <footer className="footer">
      <p className="footer__text">
        {translate("footer.made_by")}&nbsp;
        <a
          href="https://treecompany.be"
          target="_blank"
          className="footer__link"
          rel="noreferrer"
        >
          Tree company
        </a>
      </p>
    </footer>
  );
}
